var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container w800"},[_c('empty',{attrs:{"title":"Adjust your bot settings here","btTo":"","img":"https://mir-s3-cdn-cf.behance.net/project_modules/disp_still/9f6465159728551.63a456b253488.gif","btLabel":"Explore new AIs"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }